import React from 'react'

function FeaturesOne() {
  return (
    <div>
      <section className="features-one">
        <div
          className="features-one-shape-1 wow fadeInLeft animated"
          data-wow-duration="1500ms"
          data-wow-delay="100ms"
        />
        <div
          className="features-one-shape-2 wow fadeInRight animated"
          data-wow-duration="1500ms"
          data-wow-delay="200ms"
        />
        <div className="container">
          <div
            className="section-title text-center wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="200ms"
          >
            <h2>
              Popular Digital Marketing Services to Build your Business
            </h2>
          </div>
          <div
            className="section-details text-center wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
          >
            <p>
              Digital marketing &amp; advertising approach focuses on
              capturing the essential
            </p>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="features-one-box features-one-box-1 text-center wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <div className="features-one-icon-box icon-box-1">
                  <i className="icon-bullhorn" />
                </div>
                <div className="features-one-title-box">
                  <h3>Paid Social Media Marketing</h3>
                </div>
                <div className="features-one-detail-box">
                  <p>
                    Sed persiciat undomnis natus voluptat accusantic
                    doloremque laudantiue
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="features-one-box features-one-box-2 text-center wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div className="features-one-icon-box icon-box-2">
                  <i className="icon-laptop-code" />
                </div>
                <div className="features-one-title-box">
                  <h3>Website Optimization and marketing</h3>
                </div>
                <div className="features-one-detail-box">
                  <p>
                    We denounce with right indignation &amp; dislike men
                    beguiled demoralized
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="features-one-box features-one-box-3 text-center wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                <div className="features-one-icon-box icon-box-3">
                  <i className="icon-envelopes-bulk" />
                </div>
                <div className="features-one-title-box">
                  <h3>Email ans SMS Marketing Services</h3>
                </div>
                <div className="features-one-detail-box">
                  <p>
                    But must explain to you how all the mistaken ideof
                    denouncing pleasure
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div
                className="features-one-box features-one-box-4 text-center wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="700ms"
              >
                <div className="features-one-icon-box icon-box-4">
                  <i className="icon-chart-mixed" />
                </div>
                <div className="features-one-title-box">
                  <h3>Make Data-Driven Decisions</h3>
                </div>
                <div className="features-one-detail-box">
                  <p>
                    Sed perspice undomnis natus voluptate accustiue
                    doloremque laudantiue
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FeaturesOne
